__turbopack_context__.v({
  "billable": "planning-hours-visual-module__XAlMua__billable",
  "bookingInner": "planning-hours-visual-module__XAlMua__bookingInner",
  "bookingInnerVisible": "planning-hours-visual-module__XAlMua__bookingInnerVisible",
  "bookingPlaceholder": "planning-hours-visual-module__XAlMua__bookingPlaceholder",
  "bookingPlaceholderGone": "planning-hours-visual-module__XAlMua__bookingPlaceholderGone",
  "bookingSlot": "planning-hours-visual-module__XAlMua__bookingSlot",
  "button": "planning-hours-visual-module__XAlMua__button",
  "buttonDone": "planning-hours-visual-module__XAlMua__buttonDone",
  "checkGlyph": "planning-hours-visual-module__XAlMua__checkGlyph",
  "checkGlyphVisible": "planning-hours-visual-module__XAlMua__checkGlyphVisible",
  "checkbox": "planning-hours-visual-module__XAlMua__checkbox",
  "checkboxChecked": "planning-hours-visual-module__XAlMua__checkboxChecked",
  "checklistLabel": "planning-hours-visual-module__XAlMua__checklistLabel",
  "checklistLabelDone": "planning-hours-visual-module__XAlMua__checklistLabelDone",
  "columns": "planning-hours-visual-module__XAlMua__columns",
  "headerSlot": "planning-hours-visual-module__XAlMua__headerSlot",
  "headerStat": "planning-hours-visual-module__XAlMua__headerStat",
  "headerStatOut": "planning-hours-visual-module__XAlMua__headerStatOut",
  "mention": "planning-hours-visual-module__XAlMua__mention",
  "mentionAvatar": "planning-hours-visual-module__XAlMua__mentionAvatar",
  "mentionIn": "planning-hours-visual-module__XAlMua__mentionIn",
  "mentionMeta": "planning-hours-visual-module__XAlMua__mentionMeta",
  "mentionName": "planning-hours-visual-module__XAlMua__mentionName",
  "mentionTick": "planning-hours-visual-module__XAlMua__mentionTick",
  "modal": "planning-hours-visual-module__XAlMua__modal",
  "notifyCard": "planning-hours-visual-module__XAlMua__notifyCard",
  "notifyIcon": "planning-hours-visual-module__XAlMua__notifyIcon",
  "notifySlot": "planning-hours-visual-module__XAlMua__notifySlot",
  "notifyVisible": "planning-hours-visual-module__XAlMua__notifyVisible",
  "root": "planning-hours-visual-module__XAlMua__root",
  "scrim": "planning-hours-visual-module__XAlMua__scrim",
  "scrimVisible": "planning-hours-visual-module__XAlMua__scrimVisible",
  "statusCol": "planning-hours-visual-module__XAlMua__statusCol",
  "statusDot": "planning-hours-visual-module__XAlMua__statusDot",
  "statusDotActive": "planning-hours-visual-module__XAlMua__statusDotActive",
  "statusLabel": "planning-hours-visual-module__XAlMua__statusLabel",
});
